// @ts-nocheck
import trackSelectPromotion, {
    TrackSelectPromotionParameters,
} from "@store/Framework/Common/GoogleAnalytics/trackers/trackSelectPromotion";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackSelectPromotion = (
    parameters: PartialSpecific<TrackSelectPromotionParameters, "items"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return (
        callParameters: Partial<TrackSelectPromotionParameters> = {},
        callOptions?: Toolkit.GoogleAnalytics.Options,
    ) => {
        return trackSelectPromotion({ ...parameters, ...callParameters }, { ...options, ...callOptions });
    };
};

export default useTrackSelectPromotion;
